import { render, staticRenderFns } from "./uci51LCPrelab1Q5.vue?vue&type=template&id=423b4de6&scoped=true&"
import script from "./uci51LCPrelab1Q5.vue?vue&type=script&lang=js&"
export * from "./uci51LCPrelab1Q5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b4de6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VImg,VRow,VSelect})
